import { Chrome, Apple, Loader2 } from "lucide-react";

interface SSOManagementSectionProps {
  isGoogleConnected: boolean;
  isAppleConnected: boolean;
  googleEmail?: string;
  appleEmail?: string;
  onToggleGoogle: () => void;
  onToggleApple: () => void;
  /** True while link/unlink Google request in flight */
  googleBusy?: boolean;
  /** True while link/unlink Apple request in flight */
  appleBusy?: boolean;
}

export function SSOManagementSection({
  isGoogleConnected,
  isAppleConnected,
  googleEmail,
  appleEmail,
  onToggleGoogle,
  onToggleApple,
  googleBusy = false,
  appleBusy = false,
}: SSOManagementSectionProps) {
  return (
    <div className="bg-card rounded-xl shadow-sm border border-border">
      <div className="p-6 border-b border-border">
        <h2 className="font-medium mb-1">Métodos de Autenticação</h2>
        <p className="text-sm text-muted-foreground">
          Gerencie como você acessa sua conta
        </p>
      </div>

      <div className="divide-y divide-border">
        {/* Google SSO */}
        <div className="p-6">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
              <Chrome className="w-6 h-6 text-red-600" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-medium mb-1">Google</h3>
              <p className="text-sm text-muted-foreground mb-3">
                {isGoogleConnected
                  ? `Conectado como ${googleEmail || "usuário do Google"}`
                  : "Faça login rápido com sua conta Google"}
              </p>
              {isGoogleConnected ? (
                <button
                  type="button"
                  onClick={onToggleGoogle}
                  disabled={googleBusy}
                  className="px-4 py-2 border border-border rounded-lg text-sm font-medium hover:bg-accent transition-colors disabled:opacity-60 inline-flex items-center gap-2"
                >
                  {googleBusy ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
                  Desconectar
                </button>
              ) : (
                <button
                  type="button"
                  onClick={onToggleGoogle}
                  disabled={googleBusy}
                  className="px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:bg-primary/90 transition-colors disabled:opacity-60 inline-flex items-center gap-2"
                >
                  {googleBusy ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
                  Conectar Google
                </button>
              )}
            </div>
            {isGoogleConnected && (
              <div className="px-3 py-1 bg-green-100 text-green-700 text-xs font-medium rounded-full">
                Ativo
              </div>
            )}
          </div>
        </div>

        {/* Apple SSO */}
        <div className="p-6">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0">
              <Apple className="w-6 h-6 text-gray-900" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-medium mb-1">Apple</h3>
              <p className="text-sm text-muted-foreground mb-3">
                {isAppleConnected
                  ? `Conectado como ${appleEmail || "usuário da Apple"}`
                  : "Use seu Apple ID para fazer login"}
              </p>
              {isAppleConnected ? (
                <button
                  type="button"
                  onClick={onToggleApple}
                  disabled={appleBusy}
                  className="px-4 py-2 border border-border rounded-lg text-sm font-medium hover:bg-accent transition-colors disabled:opacity-60 inline-flex items-center gap-2"
                >
                  {appleBusy ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
                  Desconectar
                </button>
              ) : (
                <button
                  type="button"
                  onClick={onToggleApple}
                  disabled={appleBusy}
                  className="px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:bg-primary/90 transition-colors disabled:opacity-60 inline-flex items-center gap-2"
                >
                  {appleBusy ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
                  Conectar Apple
                </button>
              )}
            </div>
            {isAppleConnected && (
              <div className="px-3 py-1 bg-green-100 text-green-700 text-xs font-medium rounded-full">
                Ativo
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
